import { render, staticRenderFns } from "./JanusChannelCall.vue?vue&type=template&id=02d1398b&lang=pug&"
import script from "./JanusChannelCall.vue?vue&type=script&lang=js&"
export * from "./JanusChannelCall.vue?vue&type=script&lang=js&"
import style0 from "./JanusChannelCall.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports